export default function assert(expression, object) {
  if (!expression)
    throw new Error('Assertion failed:', object);
}
